module.exports = __webpack_public_path__ + "img/map_brasil_christmast.aee282eb.png";